import React, { Component } from 'react';
import styles from './CarouselHeader.css';

const debug = _debug('app:CarouselHeader');
class CarouselHeader extends Component {
  static propTypes = {
    closeCarousel: React.PropTypes.func,
    clickedIndex: React.PropTypes.number,
    CarousalHeaderTitle: React.PropTypes.string,
    CarousalHeaderSubTitle: React.PropTypes.string
  }
  constructor(props) {
    super(props);
    debug(this.props.CarousalHeaderTitle);
  }
  render() {
    return (
      <div className={styles.carouselHeader} >
        <div className={styles.headerDiv}>
          <span className={styles.labelHeader}>{this.props.CarousalHeaderTitle}</span>
        </div>
        <div className={styles.secondheaderDiv}>
          <span className={styles.secondHeaderLabel} >
            {this.props.CarousalHeaderSubTitle}
          </span>
        </div>
        <div className={styles.headerClose}>
          <input
            type="image"
            src="static/popup_close_btn.png"
            alt="Close"
            className={styles.closeButton}
            onClick={() => this.props.closeCarousel(this.props.clickedIndex)}
          />
        </div>
      </div>
    );
  }
}
export default CarouselHeader;



// WEBPACK FOOTER //
// ./src/components/CarouselHeader/CarouselHeader.js